import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import { reducer } from './reducer'
import { Chart } from './Chart'
// import { Config } from './Config'
import Config from './Config'

//TODO: remove comments and change type
const type = 'circular2'
const defaultProps = {
    verticalAlign: 'bottom',
    align: 'center',
    layout: 'horizontal',
    enabled: true,
    type_1: '',
    type_2: '',
    // type_1: 'percent',
    // type_2: 'hide',
    text: ''
}
console.log("render app")
const config = function({ type, defaultProps = {} }) {
    return Config => {
        widgetService.config(type, {
            ...defaultProps,
            snapshot: true
        })
        widgetService.ui(type, {
            configForm: Config
        })
    }
}

export default widgetService.register({
    type,
    get name() {
        return 'Circular Goal'
    },
    get description() {
        return ''
    },
    config: defaultProps,
    policies: { legends: false, defaultReducer: '@latest', layers: 1 },
    // the wrapper is needed to enable the reducer mechanism and comply the API
    impl: reactWidgetWrapper<ChartState, ChartMessage, ChartConfig>(
        Chart,
        reducer,
        config({ type, defaultProps })(Config)
    )
})
